export default __webpack_public_path__ + "static/media/1-1.aa423a8b.png";